export default function AreaArchitectSeo() {
  return (
    <>
      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "0 0 12px" }}>
        Geometry as construction, not memorization
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Geometry students learn the area of a triangle (½ base × height),
        the area of a rectangle (length × width), and the area of a circle
        (πr²), and then face problems that ask for the area of compound
        shapes — a square with a triangle cut out, a circle inside a rectangle,
        an L-shape made of two rectangles. These problems test whether you
        can *decompose* — can you see the complex shape as a combination of
        simpler ones, and can you reassemble it from the components? Area
        Architect makes that decomposition the game itself.
      </p>

      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "24px 0 12px" }}>
        How the puzzles work
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Each puzzle gives you a target area and a collection of basic shapes
        (squares, rectangles, triangles, sometimes circles) of specific sizes.
        Your job is to compose a combination whose total area equals the
        target exactly. There's usually more than one valid combination,
        which teaches the deeper lesson: area is additive and decomposable,
        not the property of a particular shape. The same total can come from
        many different shape arrangements. Every puzzle has at least one
        verified solution (the test suite exhaustively solution-searches
        all 10).
      </p>

      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "24px 0 12px" }}>
        The skill being trained
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Decomposition is the central move in geometry beyond the basics. The
        student who solves a hard compound-shape problem isn't doing it by
        applying a single formula — they're seeing the shape, mentally
        splitting it into parts that each have known formulas, summing the
        results. Area Architect trains that mental motion explicitly: you
        do nothing but decompose, all the way through.
      </p>
    </>
  );
}
